import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { Scrollbar } from 'app/components/index';
import React from 'react';

const AutocolonList = ({ isCheckboxDisabled, items, expanded, handleAccordionChange, handleItemClick, handleCheckAllDivision }) => {
  return (
    <Box
      sx={{
        width: '100%',
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
      }}>
      <Stack
        direction='column'
        sx={(theme) => ({
          '.simplebar-content-wrapper': {
            padding: theme.spacing(0),
            minHeight: 'auto',
            paddingRight: '12px',
          },
          '.MuiAccordion-root': {
            borderRadius: '0',
            overflow: 'hidden',
            width: '100%',
            transition: 'background-color ' + theme.transitions.duration.shortest + 'ms ' + theme.transitions.easing.easeInOut + ' 0ms',
            '&:before': {
              display: 'none',
            },
            '&:last-of-type': {
              margin: '0!important',
            },
            '&.Mui-expanded': {
              margin: '0',
            },
            '&.Mui-disabled': {
              bgcolor: 'background.paper',
              '.MuiAccordionSummary-root': {
                opacity: '1',
              },
              '.MuiAccordionSummary-expandIconWrapper': {
                display: 'none',
              },
            },
            '.MuiAccordionSummary-expandIconWrapper': {
              svg: {
                fontSize: '18px',
              },
            },
          },
          '.MuiAccordionSummary-root': {
            padding: theme.spacing(0, 0, 0, 2),
            minHeight: '24px',
            transition: 'none',
            bgcolor: '#f5f6fa',
            '&:hover': {
              bgcolor: 'background.default',
              borderRadius: '0',
            },
            '&.Mui-expanded': {
              minHeight: '24px',
              borderRadius: '0',
              '.MuiAccordionSummary-expandIconWrapper': {},
            },
          },
          '.MuiAccordionSummary-content': {
            alignItems: 'center',
            overflow: 'hidden',
            justifyContent: 'space-between',
            margin: theme.spacing(0),
            '&.Mui-expanded': {
              margin: theme.spacing(0),
            },
            '.MuiCheckbox-root': {
              justifyContent: 'flex-start',
              padding: theme.spacing(0),
              svg: {
                fontSize: '18px',
              },
            },
          },
          '.MuiCheckbox-root': {
            marginRight: 0,
          },
          '.MuiListItemButton-root': {
            marginRight: 0,
          },
          '.MuiAccordionDetails-root': {
            padding: theme.spacing(0),
            '.MuiList-root': {
              margin: '2px 0',
            },
          },
        })}>
        <Scrollbar>
          {items.map(({ id, name, autocolons, checked }) => {
            const isSelectedDivision = false;
            const selectedAutocolon = false;
            return (
              <Stack
                direction='row'
                key={id}
                sx={(theme) => ({
                  bgcolor: isSelectedDivision ? theme.palette.primary.main : '',
                  '&:hover': {
                    bgcolor: isSelectedDivision ? '#838aef' : '',
                  },
                })}>
                <Accordion
                  square
                  elevation={0}
                  disabled={autocolons.length === 0}
                  expanded={expanded[id]}
                  selected={false}
                  TransitionProps={{ unmountOnExit: true }}>
                  <Stack
                    direction='row'
                    sx={(theme) => ({
                      position: 'relative',
                      '.MuiAccordionSummary-root': {
                        width: '100%',
                        bgcolor: isSelectedDivision ? '#6576ff' : '',
                        color: isSelectedDivision ? theme.palette.primary.contrastText : 'inherit',
                        '&:hover': {
                          bgcolor: isSelectedDivision ? '#838aef' : '',
                        },
                      },
                    })}>
                    <AccordionSummary disableRipple expandIcon={<ExpandMore onClick={() => handleAccordionChange(id)} />}>
                      <Stack
                        direction={'row'}
                        justifyContent={'space-between'}
                        onClick={(e) =>
                          handleCheckAllDivision(e, {
                            id,
                            name,
                            autocolons,
                            checked,
                          })
                        }
                        width={'100%'}>
                        <Typography>
                          {name} ({autocolons.length})
                        </Typography>
                      </Stack>
                    </AccordionSummary>
                    <Stack
                      sx={(theme) => ({
                        bgcolor: theme.palette.background.default,
                        color: isSelectedDivision ? theme.palette.primary.contrastText : 'inherit',
                        '&:hover': {
                          bgcolor: isSelectedDivision ? '#838aef' : '',
                        },
                      })}>
                      <ListItemIcon
                        sx={{
                          minWidth: '18px',
                        }}>
                        <Checkbox size='small' edge='end' disableRipple disabled={isCheckboxDisabled} checked={checked} />
                      </ListItemIcon>
                    </Stack>
                  </Stack>
                  <AccordionDetails>
                    <List
                      disablePadding
                      sx={(theme) => ({
                        '& .Mui-selected': {
                          bgcolor: theme.palette.primary.main + '!important',
                          color: theme.palette.primary.contrastText,
                        },
                      })}>
                      {autocolons.map((autocolon) => (
                        <Stack direction='row' key={`autocolon${autocolon.id}`}>
                          <ListItemButton
                            disablePadding
                            selected={autocolon.id === selectedAutocolon}
                            onClick={() => handleItemClick(autocolon)}
                            sx={(theme) => ({
                              padding: theme.spacing(0.5, 1),
                              paddingLeft: '36px',
                              paddingRight: '0',
                              borderRadius: '0',
                              '&:hover': {
                                bgcolor: 'background.default',
                                cursor: 'pointer',
                              },
                              '.MuiListItemIcon-root': {
                                minWidth: '26px',
                                '.MuiCheckbox-root': {
                                  padding: '0',
                                  justifyContent: 'flex-start',
                                  svg: {
                                    fontSize: '18px',
                                  },
                                },
                              },
                              '.MuiListItemText-root': {
                                margin: theme.spacing(0),
                              },
                            })}>
                            <ListItemText primary={autocolon.name} />
                            <Checkbox size='small' edge='end' disableRipple disabled={isCheckboxDisabled} checked={autocolon.checked} />
                          </ListItemButton>
                        </Stack>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
              </Stack>
            );
          })}
        </Scrollbar>
      </Stack>
    </Box>
  );
};

export default AutocolonList;
